export const siteSettings = {
  name: "Lead Master Stocks",
  link: "https://optfnx.leadmasterstocks.com/",
  email: "support@app.leadmasterstocks.com",
  appLink: "https://app.leadmasterstocks.com",
};
